import {Button, Popconfirm, Space, Table} from "antd";
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import './index.scss'
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

const EmployeeTable = ({data}) => {
    const navigate = useNavigate();
    const ScreenMD = useBreakpoint().md;


    const Edit = (id) => {
        navigate(`/employee/add?editId=${id}`)
    };


    const columns = [

        {
            title: 'Сотрудник Ф.И.О',
            dataIndex: 'user_name',
            render: (text) => <p>{text}</p>

        },
        {
            title: 'Должность',
            dataIndex: 'position',
            render: (text) => <p>{text}</p>

        },
        {
            title: 'Офис',
            dataIndex: 'officeId',
            render: (text) => <p>{text.name}</p>,
        },


        {
            title: 'Событие',

            render: (_, record) => (
                <Space direction={ScreenMD ? 'horizontal' : 'vertical'} size={[3, 10]}>

                    <>
                        <Button size={ScreenMD ? 'middle' : 'small'} onClick={() => Edit(record._id)} type='dashed'
                                icon={<EditOutlined/>}/>

                    </>


                </Space>
            ),
        },
    ];

    return (
        <Table
            className={'work-time'}
            size='small'
            columns={columns}
            dataSource={data}
            rowKey={(record) => record._id}
            pagination={{responsive: true}}
        />
    );
};

export default EmployeeTable;
